export default "__VITE_ASSET__D4GP1cwJ__"